<template>
<div class="link-container">
    <div class="link-detail">
        <p>{{link.label}}</p>
        <p>{{link.url}}</p>
        <input type="hidden" ref="link" :value="link.url">
        <font-awesome-icon @click="copie" icon="copy" class="icon"/>
    </div>
    
</div>
</template>
<script>

export default {
    props:{
        link:{
            type:Object
        }
    },
    methods:{
        copie(){
            var link = this.$refs.link;
            console.log(link);
            link.setAttribute('type', 'text');
            link.select();
             try {
            var successful = document.execCommand('copy');
            link.setAttribute('type', 'hidden');
          } catch (err) {
            console.log('unable to copy');
          }
        }
    }
    
}
</script>
<style scoped>
p{
    padding:0px 10px;
}
.link-container{

}
.link-detail{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(144, 144, 144, 0.27);
}
.icon{
    width: 15px;
    height: 15px;
    color:#909090;
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// node_modules/modal-export/src/components/LinkComponent.vue